import { useCallback, useState } from 'react';

export const getRequiredFieldProps = (showError: boolean) => ({
	required: true,
	error: showError,
	helperText: showError ? 'Required' : undefined,
});

export const usePropertySaveValidation = (canSave: boolean) => {
	const [saveAttempted, setSaveAttempted] = useState(false);

	const validateForSave = useCallback(() => {
		setSaveAttempted(true);
		return canSave;
	}, [canSave]);

	const resetValidation = useCallback(() => {
		setSaveAttempted(false);
	}, []);

	return { saveAttempted, validateForSave, resetValidation };
};
